import { styled } from '@mui/material';

const StyledSeparator = styled('div')({
  width: '100%',
  height: 1,
  borderBottom: '1px solid var(--stroke-stroke-primary-color)',
});

export const Separator = () => {
  return <StyledSeparator />;
};
